import 'svelte/internal/disclose-version';

Pass[$.FILENAME] = 'src/web/concepts/pass.svelte';

import * as $ from 'svelte/internal/client';
import SlotPicker from "./slot_picker.svelte";

var root = $.add_locations($.from_html(`<p class="text-2xl font-semibold">✓ Boarding confirmed</p>`), Pass[$.FILENAME], [[36, 16]]);

var root_1 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-5xl grid md:grid-cols-2 gap-10 items-start">
  <form class="flex flex-col gap-5">
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">Get your pass to a custom OS.</h1>
    <input class="field" placeholder="Company" required=""/>
    <input class="field" placeholder="What should it do?" required=""/>
    <input class="field" type="email" placeholder="Work email" required=""/>
    <!>
    <button class="btn self-start"> </button>
  </form>

  <div>
    <div class="flex justify-between text-sm opacity-70"><span>CREAGEEN · ONBOARDING</span><span class="tabular-nums"> </span></div>
    <div>
      <span class="text-sm opacity-70">PASSENGER</span>
      <p class="text-3xl font-semibold truncate"> </p>
    </div>
    <div>
      <span class="text-sm opacity-70">DESTINATION</span>
      <p class="text-xl font-semibold line-clamp-2"> </p>
    </div>
    <div class="flex justify-between border-t border-dashed border-accent/40 pt-4">
      <div><span class="text-sm opacity-70">DEPARTURE</span><p class="font-semibold"> </p></div>
      <div class="text-right"><span class="text-sm opacity-70">GATE</span><p class="font-semibold">Video call</p></div>
    </div>
    <!>
  </div>
</div>`,
		1
	),
	Pass[$.FILENAME],
	[
		[
			12,
			0,
			[
				[13, 2, [[14, 4], [15, 4], [16, 4], [17, 4], [19, 4]]],
				[
					22,
					2,
					[
						[23, 4, [[23, 57], [23, 91]]],
						[24, 4, [[25, 6], [26, 6]]],
						[28, 4, [[29, 6], [30, 6]]],
						[
							32,
							4,
							[[33, 6, [[33, 11], [33, 60]]], [34, 6, [[34, 30], [34, 74]]]]
						]
					]
				]
			]
		]
	]
);

function Pass($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Pass);

	let company = $.tag($.state(""), 'company');
	let need = $.tag($.state(""), 'need');
	let email = $.tag($.state(""), 'email');
	let slot = $.tag($.state(null), 'slot');
	let issued = $.tag($.state(false), 'issued');
	const code = `CG-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_1();
	var div = $.sibling($.first_child(fragment));
	var form = $.sibling($.child(div));
	var input = $.sibling($.child(form), 3);

	$.remove_input_defaults(input);

	var input_1 = $.sibling(input, 2);

	$.remove_input_defaults(input_1);

	var input_2 = $.sibling(input_1, 2);

	$.remove_input_defaults(input_2);

	var node = $.sibling(input_2, 2);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			$.add_svelte_meta(
				() => SlotPicker(node_1, {
					get value() {
						return $.get(slot);
					},

					set value($$value) {
						$.set(slot, $$value, true);
					}
				}),
				'component',
				Pass,
				18,
				17,
				{ componentTag: 'SlotPicker' }
			);

			$.append($$anchor, fragment_1);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(issued)) $$render(consequent);
			}),
			'if',
			Pass,
			18,
			4
		);
	}

	var button = $.sibling(node, 2);
	var text = $.only_child(button, true);

	$.next();
	$.reset(form);

	var div_1 = $.sibling(form, 2);
	var div_2 = $.sibling($.child(div_1));
	var span = $.sibling($.child(div_2));
	var text_1 = $.only_child(span, true);

	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var p = $.sibling($.child(div_3), 3);
	var text_2 = $.only_child(p, true);

	$.next();
	$.reset(div_3);

	var div_4 = $.sibling(div_3, 2);
	var p_1 = $.sibling($.child(div_4), 3);
	var text_3 = $.only_child(p_1, true);

	$.next();
	$.reset(div_4);

	var div_5 = $.sibling(div_4, 2);
	var div_6 = $.sibling($.child(div_5));
	var p_2 = $.sibling($.child(div_6));
	var text_4 = $.only_child(p_2, true);

	$.reset(div_6);
	$.next(3);
	$.reset(div_5);

	var node_2 = $.sibling(div_5, 2);

	{
		var consequent_1 = ($$anchor) => {
			var p_3 = root();

			$.append($$anchor, p_3);
		};

		$.add_svelte_meta(
			() => $.if(node_2, ($$render) => {
				if ($.get(issued)) $$render(consequent_1);
			}),
			'if',
			Pass,
			36,
			4
		);
	}

	$.next();
	$.reset(div_1);
	$.next();
	$.reset(div);

	$.template_effect(() => {
		input.disabled = $.get(issued);
		input_1.disabled = $.get(issued);
		input_2.disabled = $.get(issued);
		button.disabled = !$.get(slot) || $.get(issued);
		$.set_text(text, $.get(issued) ? "Pass issued, check your inbox" : "Issue my pass");

		$.set_class(div_1, 1, $.clsx([
			"bg-ink text-accent p-6 md:p-8 flex flex-col gap-6 font-display transition-transform duration-500",
			$.get(issued) && "-rotate-2 scale-105"
		]));

		$.set_text(text_1, code);
		$.set_text(text_2, $.get(company) || "Your company");
		$.set_text(text_3, $.get(need) || "Its own OS");
		$.set_text(text_4, $.get(slot) ?? "Pick a time");
	});

	$.event('submit', form, function submit(e) {
		e.preventDefault();
		$.set(issued, true);
	});

	$.bind_value(
		input,
		function get() {
			return $.get(company);
		},
		function set($$value) {
			$.set(company, $$value);
		}
	);

	$.bind_value(
		input_1,
		function get() {
			return $.get(need);
		},
		function set($$value) {
			$.set(need, $$value);
		}
	);

	$.bind_value(
		input_2,
		function get() {
			return $.get(email);
		},
		function set($$value) {
			$.set(email, $$value);
		}
	);

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Pass = $.hmr(Pass);

	import.meta.hot.accept((module) => {
		Pass[$.HMR].update(module.default);
	});
}

export default Pass;